@import "~/styles/v1/_variables.scss";
@import "~/styles/v1/_spacing.scss";

.ResourceDuplicates {
  overflow: auto;
  z-index: 1;
  padding: $size-M $size-M 0 $size-M;

  .details {
    background: $system_sun-base;
    border-radius: $border-radius-base;
    padding: $size-S;
  }

  .icon {
    margin-right: $size-S;
    margin-top: -4px;
  }

  .resource {
    border: none;
  }
}
